<ng-container *ngIf="params.isPickInput">
  <input
    class="input-container_input input-container_input--small w-100"
    type="number"
    [formControl]="pick"
    (keypress)="restrictMinus($event)"
    (input)="onChange($event)" 
    [ngClass]="{ 'ng-invalid': params?.data?.QtyFound > params.data.QtyToPick }"
    [min]="1"
  />
</ng-container>
<ng-container *ngIf="!params.isScan && params.data.isSubmitButton && (!params.isPickIcon && !params.isPickInput)">
  <app-button [buttonSize]="'action'" (click)="submitPick()">Submit Pick</app-button>
</ng-container>

<ng-container *ngIf="params.isScan">
  <div class="sku-scanned ms-auto"><span class="bullet" [ngClass]="params.data.scanned ? '' : 'bg-danger'"></span></div>
</ng-container>
